import { createSlice } from "@reduxjs/toolkit";
import { VisualSupport } from "domain/entities/visual-supports.entities";
import {
  getFavoritesVisualSupports,
  getRandomVisualSupport,
  getVisualSupport,
  getVisualSupports,
  setIsVisualSupportLoading,
} from "domain/visual-supports/visual-supports.actions";

export type VisualSupportsState = {
  isVisualSupportsLoading: boolean;
  supports: VisualSupport[];
  isVisualSupportLoading: boolean;
  support: VisualSupport;
  totalCount: number;
  randomVisualSupport: VisualSupport | null;
};

const initialState: VisualSupportsState = {
  isVisualSupportsLoading: false,
  supports: [],
  isVisualSupportLoading: false,
  support: null,
  totalCount: 0,
  randomVisualSupport: null,
};

export const visualSupportsSlice = createSlice({
  name: "visualSupports",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //GET VISUAL SUPPORTS
    builder.addCase(getVisualSupports.fulfilled, (state, action) => {
      state.supports = action.payload.supports;
      state.totalCount = action.payload.totalCount;
      state.isVisualSupportsLoading = false;
    });
    builder.addCase(getVisualSupports.pending, (state, action) => {
      state.isVisualSupportsLoading = true;
    });
    //SET IS VISUAL SUPPORT LOADING
    builder.addCase(setIsVisualSupportLoading.fulfilled, (state, action) => {
      state.isVisualSupportLoading = action.payload.isLoading;
    });
    //GET VISUAL SUPPORT
    builder.addCase(getVisualSupport.fulfilled, (state, action) => {
      state.support = action.payload.support;
      state.isVisualSupportLoading = false;
    });
    builder.addCase(getVisualSupport.pending, (state, action) => {
      state.isVisualSupportLoading = true;
    });
    //GET FAVORITES VISUAL SUPPORTS
    builder.addCase(getFavoritesVisualSupports.fulfilled, (state, action) => {
      state.supports = action.payload.supports;
      state.isVisualSupportsLoading = false;
    });
    builder.addCase(getFavoritesVisualSupports.pending, (state, action) => {
      state.isVisualSupportsLoading = true;
    });
    //GET RANDOM VISUAL SUPPORT
    builder.addCase(getRandomVisualSupport.fulfilled, (state, action) => {
      state.randomVisualSupport = action.payload.support;
      state.isVisualSupportLoading = false;
    });
    builder.addCase(getRandomVisualSupport.pending, (state, action) => {
      state.isVisualSupportLoading = true;
    });
  },
});
